import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from 'styled-components';
import { Icon } from '@fnacdarty/back-office-ui';
import { StyledNav, StyledIconGroup } from './index.styled';

const TwoFactorHeadBand = ({ closeMode }) => {
	const theme = useTheme();
	return (
		<StyledNav $center={true}>
			<span>Authentification à double facteur</span>

			<StyledIconGroup>
				<Icon
					name="x"
					width="24"
					color={theme.colors.text}
					onClick={closeMode}
				/>
			</StyledIconGroup>
		</StyledNav>
	);
};

TwoFactorHeadBand.propTypes = {
	closeMode: PropTypes.func,
};

export default TwoFactorHeadBand;
